export const isNull = element => element === null

/**
 * @deprecated
 */
export const formatDate = (locale, date) => {
  if (date && date.length === 10) {
    const [year, month, day] = date.split('-')
    if (locale === 'en-US') {
      return `${month}/${day}/${year}`
    }
    return `${day}/${month}/${year}`
  }
  return date
}

/**
 * @deprecated
 */
export const formatToInputHours = unFormateDate => {
  const newUnFormateDate = new Date(unFormateDate)

  return `${
    newUnFormateDate.getHours() <= 9 ? '0' : ''
  }${newUnFormateDate.getHours()}:00`
}

/**
 * @deprecated
 */
export const formatToInputDate = (locale, unFormateDate) => {
  const newUnFormateDate = new Date(unFormateDate)

  if (locale === 'en-US') {
    return `${
      newUnFormateDate.getMonth() >= 9
        ? newUnFormateDate.getMonth() + 1
        : '0' + (newUnFormateDate.getMonth() + 1)
    }/${
      newUnFormateDate.getDate() > 9
        ? newUnFormateDate.getDate()
        : '0' + newUnFormateDate.getDate()
    }`
  } else {
    return `${
      newUnFormateDate.getDate() > 9
        ? newUnFormateDate.getDate()
        : '0' + newUnFormateDate.getDate()
    }/${
      newUnFormateDate.getMonth() >= 9
        ? newUnFormateDate.getMonth() + 1
        : '0' + (newUnFormateDate.getMonth() + 1)
    }`
  }
}

/**
 * @deprecated
 */
export const formatToDateTime = (locale, unFormateDate) => {
  return `${formatToInputDate(locale, unFormateDate)} ${formatToInputHours(
    unFormateDate
  )}`
}

/**
 * @deprecated
 */
export const createSinceDate = date => {
  const start = new Date(`${date}T00:00:00Z`)
  return start.toISOString()
}

/**
 * @deprecated
 */
export const createUntilDate = date => {
  const end = new Date(`${date}T23:59:59Z`)
  return end.toISOString()
}
